import {
  Button,
  ButtonVariant,
  IFalconTheme,
  Layout,
  ResponsiveTypographyVariant,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../../common/contexts/TranslationsContext';
import { ConfirmationDisclaimerText } from '../CancellationPage.styles';

export const CancellationConfirmation: (
  handleConfirm: () => void,
  creditRefund: boolean,
  cancellationRequested: boolean,
  handleClose: () => void,
  theme?: IFalconTheme
) => JSX.Element = (handleConfirm, creditRefund, cancellationRequested, handleClose, theme) => {
  const { translations } = React.useContext(TranslationsContext);
  window.scrollTo(0, 0);

  return (
    <React.Fragment>
      <ConfirmationDisclaimerText
        color={theme.color.grey60}
        variant={ResponsiveTypographyVariant.body}
      >
        {i18n(
          creditRefund ? 'cancellation.confirmation.credit' : 'cancellation.confirmation',
          [],
          translations
        )}
      </ConfirmationDisclaimerText>
      <Layout.Container justifyContent={'space-between'}>
        <Button variant={ButtonVariant.text} onClick={handleClose}>
          {i18n('cancellation.keep', [], translations)}
        </Button>
        <Button
          variant={ButtonVariant.primary}
          onClick={handleConfirm}
          showLoader={cancellationRequested}
          dataAttributes={{ testid: 'confirmCancelButton' }}
        >
          {i18n('cancellation.yes.cancel', [], translations)}
        </Button>
      </Layout.Container>
    </React.Fragment>
  );
};
